import React, { useState } from 'react';
import { Button, Input } from 'rsuite';
import api from '../../../services/api';
import RModal from '../../../components/Rsuite/Modal';
import theme from '../../../theme';
import { useAuth } from '../../../hooks/auth';
import { toastError, toastSuccess } from '../../../toasts';

const ImportarBairros = ({ open, close, setBairros }) => {
  const { id_empresa } = useAuth();
  const [codEmpresa, setCodEmpresa] = useState('');
  const [desabilitar, setDesabilitar] = useState(false);

  const importar = async () => {
    setDesabilitar(true);
    if (codEmpresa) {
      if (!Number(codEmpresa) || Number(codEmpresa) === Number(id_empresa)) {
        toastError('Não é possível importar da mesma empresa');
      }

      try {
        const { data } = await api.post('bairro/importarBairros', {
          IdEmpresa: id_empresa,
          CodEmpresaImport: codEmpresa,
        });

        setBairros((state) => [...state, ...data]);
        toastSuccess('Bairros importados');

        close();
      } catch (error) {
        console.log(error);
        toastError('Não é possível importar da mesma empresa');
      }
    } else {
      toastError('Informe o código da empresa');
    }
    setDesabilitar(false);
  };

  return (
    <RModal
      open={open}
      onClose={close}
      title="Importar bairros"
      footer={
        <>
          <Button
            onClick={importar}
            appearance="primary"
            disabled={desabilitar}
          >
            Importar
          </Button>
          <Button onClick={close} appearance="ghost">
            Fechar
          </Button>
        </>
      }
    >
      <label>
        <b style={{ color: theme.cores.black }}>Importar Bairros:</b>
      </label>
      <Input
        type="number"
        style={{ width: 230 }}
        placeholder="Informe o código da empresa"
        value={codEmpresa}
        onChange={setCodEmpresa}
      />
    </RModal>
  );
};

export default ImportarBairros;
